<template>
  <!-- <teleport to="#section-violations"> -->
    <div id="vehicle-dashboard-get-template-button-test" style="margin-left: 140px; color: black; background: unset;">
      <span class="target-show-span" style="opacity: unset; display: block;"></span>
    </div>

    <div id="my-info">
      <button
        class="not-print float-left hidden"
        @click="
            (e) =>
              html_to_excel_helper.export(
              e.target,
              'vehicle-dashboard-template-content',
              'Дашборд по эксплуатации тс (в разработке)',
              'landscape',
            )
        "
      >
        Экспорт&nbsp;в&nbsp;EXCEL
      </button>

      <button 
        @click="printElement"
      >
        Сохранить в PDF
      </button>
    </div>
    <div
      class="temlate-report"
      id="vehicle-dashboard-template-content"
    >
      <div data-excelsheet="Дашборд по эксплуатации тс (в разработке)"></div>
      <h6 class="footer-desc text-center font-weight-bold" style="min-width: 1861px;">
        Дашборд по эксплуатации тс (в разработке)
      </h6>
      <div class="table-2 table-striped" style="width: 1920px;">
        <div style="display: inline-block;margin-left: 10px;" :class="{ 'disabled-blurred': isRequestingReport }">
          <p class="footer-desc">
          <span class="footer-desc_period-label"><strong>ПЕРИОД</strong>
            <span style="display: inline-block;">
            <UiDoubleDatepicker
              v-model:date="dateRange"
              type="dashboard"
              @update:date="onDateChange"
            />
            </span>
          </span>
          <span class="footer-desc_group-label"><strong style="font-weight: 700;font-size: 20px;line-height: 20px;">ГРУППИРОВКА</strong>
            <UiSelect
              class="footer-desc_group-val"
              style="display: inline-block;position: relative;top: 6px;min-height: 12px;"
              v-model:select="groupingType2"
              :items="groupingTypeOptions"
              @update:select="onGroupingChange"
            />
          </span>
          <span>
            <!-- <button
              v-if="showRefreshButton"
              @click="refreshData"
              class="refresh-btn"
            >
              Обновить отчет
            </button> -->
          </span>
          <span style="margin-left: 73.5px;">
            <u-i-report-button
              :is-section-button="false"
              :is-form-submit="false"
              :template-button-id="'vehicle-dashboard-get-template-button'"
              :button-additional-class="'vehicle-dashboard-get-template-button-id'"
              :hint-additional-class="'vehicle-dashboard-get-template-button-target'"
              :text="'запросить данные'"
              @execute-report="executeVehicleReport"
            />

            <button
              @click="openSelectModal"
              class="select-ts-btn"
              style="margin-left: 202px"
            >
              выбрать ТС
            </button>
          </span>
          <span 
          v-if="errorText !== ''"
          class="error">
            {{ errorText }}
          </span>
        </p>
        </div>
      </div>
      
    </div>

    <!-- Модальное окно выбора ТС -->
    <VehicleDashboardSelectModal
      v-model="showSelectModal"
      :selected-ts-list="selectedTsListSync"
      v-model:filterSelected="filterSelectedSync"
      v-model:searchStr="searchStrSync"
      v-model:clientSearchStr="clientSearchStrSync"
      @apply="applyTsSelection"
    />
  <!-- </teleport> -->
</template>

<script setup>
import { ref, nextTick, watch, onMounted, onBeforeMount, onBeforeUnmount, computed, inject } from 'vue';
import { html_to_excel_helper } from '@/helpers/html_to_excel_helper';
import UiDoubleDatepicker from '@/App/Components/UiDoubleDatepicker.vue';
import UIReportButton from '@/App/Monitoring/Sidebar/components/UIReportButton.vue';
import {
  objectsListFormSubmit,
  globalObjects,
} from '../../../src/dataRequest/mainScript';
import VehicleDashboardSelectModal from './VehicleDashboardSelectModal.vue';
import UiSelect from '@/App/Monitoring/Sidebar/components/UiSelect.vue';

const printElement = () => {
  window.print();
};

const props = defineProps({
  trigger: { type: Boolean, required: true },
  form_desc: { type: Object },
  data: { type: Object, default: () => ({}) },
  areaId: { type: String },
});

let chartInstances = [null, null, null, null, null, null, null, null, null, null, null, null, null, null];
const groupingTypeOptions = [
  { value: 'day', text: 'дни' },
  { value: 'week', text: 'недели' },
  { value: 'month', text: 'месяц' },
  { value: 'quarter', text: 'квартал' },
  { value: 'season', text: 'сезон года' },
];

const testData = ref(null);
const errorText = ref("");

// Переменные для модального окна выбора ТС
const showSelectModal = ref(false);

// Флаги для отслеживания действий пользователя
const userOpenedSelectModal = ref(false);
const userChangedDateRange = ref(false);
const userChangedGroupingType = ref(false);
const firstTriggerHandled = ref(false); // Флаг для отслеживания первого срабатывания

const globalObjectsList = inject('globalObjectsList');
const objectsListUpdateTrigger = inject('objectsListUpdateTrigger');
const userData = inject('userData');
const vehicleDashboardState = inject('vehicleDashboardState');
const isRequestingReport = inject('isRequestingReport');
const emit = defineEmits(['displayReport', 'close']);

// Синхронизируем локальные состояния с глобальными
const selectedTsListSync = computed({
  get: () => vehicleDashboardState.selectedTsList,
  set: (val) => { vehicleDashboardState.selectedTsList = val; }
});
const filterSelectedSync = computed({
  get: () => vehicleDashboardState.filterSelected,
  set: (val) => { vehicleDashboardState.filterSelected = val; }
});
const searchStrSync = computed({
  get: () => vehicleDashboardState.searchStr,
  set: (val) => { vehicleDashboardState.searchStr = val; }
});
const clientSearchStrSync = computed({
  get: () => vehicleDashboardState.clientSearchStr,
  set: (val) => { vehicleDashboardState.clientSearchStr = val; }
});

const now = new Date(); 
const dateRange = ref([new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7), new Date(now.getFullYear(), now.getMonth(), now.getDate())]);
const showRefreshButton = ref(false);

const groupingType2 = ref('day');

// Function to handle date changes
const onDateChange = () => {
  userChangedDateRange.value = true;
  showRefreshButton.value = true;
};

// Function to handle grouping changes
const onGroupingChange = () => {
  userChangedGroupingType.value = true;
  // showRefreshButton.value = true;

  setDateRangeByGroupingType();

  if (selectedTsListSync.value.length > 0) {
    const fakeEvent = { ctrlKey: false, metaKey: false };
    executeVehicleReport(fakeEvent);
  }
};

// Вспомогательная функция для установки dateRange в зависимости от типа группировки
const setDateRangeByGroupingType = () => {
  const now = new Date();

  if (groupingType2.value === 'day') {
    // [за 7 дней до 00:00 этой ночи, 00:00 этой ночи]
    const tonightMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
    const sevenDaysBefore = new Date(tonightMidnight.getTime() - 7 * 24 * 60 * 60 * 1000);
    dateRange.value = [sevenDaysBefore, tonightMidnight];
  } else if (groupingType2.value === 'week') {
    // [за 4 недели до 00:00 понедельника этой недели, 00:00 понедельника этой недели]
    const dayOfWeek = now.getDay(); // 0 - воскресенье, 1 - понедельник, ...
    const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // Смещение до понедельника
    const thisMondayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + mondayOffset, 0, 0, 0);
    const fourWeeksBefore = new Date(thisMondayMidnight.getTime() - 4 * 7 * 24 * 60 * 60 * 1000);
    dateRange.value = [fourWeeksBefore, thisMondayMidnight];
  } else if (groupingType2.value === 'month') {
    // [за 4 месяца до 00:00 1 числа этого месяца, 00:00 1 числа этого месяца]
    const firstDayThisMonth = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
    const firstDayFourMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 4, 1, 0, 0, 0);
    dateRange.value = [firstDayFourMonthsAgo, firstDayThisMonth];
  } else if (groupingType2.value === 'quarter') {
    // [за 4 квартала до 00:00 начала текущего квартала, 00:00 начала текущего квартала]
    const currentMonth = now.getMonth(); // 0-11
    const currentQuarter = Math.floor(currentMonth / 3); // 0, 1, 2, 3
    const firstMonthOfQuarter = currentQuarter * 3; // 0, 3, 6, 9
    const firstDayThisQuarter = new Date(now.getFullYear(), firstMonthOfQuarter, 1, 0, 0, 0);

    // 4 квартала назад = 12 месяцев назад
    const firstDayFourQuartersAgo = new Date(now.getFullYear(), firstMonthOfQuarter - 12, 1, 0, 0, 0);
    dateRange.value = [firstDayFourQuartersAgo, firstDayThisQuarter];
  } else if (groupingType2.value === 'season') {
    // [за 4 сезона до 1 числа текущего сезона, 1 число текущего сезона]
    // Зима: декабрь (11), январь (0), февраль (1) - с 1 декабря по конец февраля
    // Весна: март (2), апрель (3), май (4) - с 1 марта по конец мая
    // Лето: июнь (5), июль (6), август (7) - с 1 июня по конец августа
    // Осень: сентябрь (8), октябрь (9), ноябрь (10) - с 1 сентября по конец ноября
    const currentMonth = now.getMonth(); // 0-11
    
    let currentSeasonStartMonth;
    if (currentMonth === 11 || currentMonth === 0 || currentMonth === 1) {
      // Зима - начинается в декабре предыдущего года
      currentSeasonStartMonth = 11; // Декабрь
    } else if (currentMonth >= 2 && currentMonth <= 4) {
      // Весна - начинается в марте
      currentSeasonStartMonth = 2; // Март
    } else if (currentMonth >= 5 && currentMonth <= 7) {
      // Лето - начинается в июне
      currentSeasonStartMonth = 5; // Июнь
    } else {
      // Осень - начинается в сентябре
      currentSeasonStartMonth = 8; // Сентябрь
    }
    
    // 1 число текущего сезона
    const firstDayThisSeason = new Date(now.getFullYear(), currentSeasonStartMonth, 1, 0, 0, 0);
    
    // 4 сезона назад = 12 месяцев назад
    const firstDayFourSeasonsAgo = new Date(now.getFullYear(), currentSeasonStartMonth - 12, 1, 0, 0, 0);
    dateRange.value = [firstDayFourSeasonsAgo, firstDayThisSeason];
  }
};


// Методы для модального окна выбора ТС
const openSelectModal = () => {
  userOpenedSelectModal.value = true;
  showSelectModal.value = true;
};

const applyTsSelection = (selectedIds) => {
  selectedTsListSync.value = selectedIds;
};

function setStatusText(text) {
  const targetElement = document.querySelector('#vehicle-dashboard-get-template-button-test .target-show-span');
  if (targetElement) {
    targetElement.textContent = text;
  }
}

function checkConditions() {
  let [start, end] = dateRange.value;

  start = Math.floor(start / 1000);
  end = Math.floor(end / 1000);

  // Проверяем, выбраны ли объекты
  if (selectedTsListSync.value.length === 0) {
    setStatusText('Не выбран ни один объект.');
    return false;
  }

  // Проверяем, выбраны ли объекты
  // if (!props.form_desc?.objects || props.form_desc.objects.length === 0) {
  //   setStatusText('Не выбран ни один объект.');
  //   return false;
  // }

  // Validation 1: End date must be after start date
  if (end <= start) {
    setStatusText('Конечная дата должна быть позже начальной.');
    return false;
  }

  // Validation 2-5: Grouping-specific range checks
  const timeDiff = end - start;
  const maxDayDiff = 7 * 24 * 60 * 60; // 7 days in s
  const maxWeekDiff = 7 * maxDayDiff; // 49 days in s

  switch (groupingType2.value) {
    case 'day':
      if (timeDiff > maxDayDiff) {
        setStatusText('Промежуток времени не должен превышать 7 дней.');
        // errorText.value = 'Промежуток времени не должен превышать 7 дней.';
        return false;
      }
      break;
    case 'week':
      if (timeDiff > maxWeekDiff) {
        setStatusText('Промежуток времени не должен превышать 49 дней.');
        // errorText.value = 'Промежуток времени не должен превышать 49 дней.';
        return false;
      }
      break;
    case 'month':
    case 'season':
    case 'quarter':
      const maxDate = new Date(start * 1000);
      const minDate = new Date(end * 1000);
      maxDate.setFullYear(maxDate.getFullYear() + 1); // Exactly 12 months later
      if (minDate > maxDate) {
        let unit;
        if (groupingType2.value === 'month') {
          unit = '12 месяцев';
        } else if (groupingType2.value === 'season') {
          unit = '4 сезона (12 месяцев)';
        } else {
          unit = '4 квартала (12 месяцев)';
        }
        setStatusText(`Промежуток времени не должен превышать ${unit} для текущей группировки.`);
        errorText.value = `Промежуток времени не должен превышать ${unit} для текущей группировки.`;
        return false;
      }
      break;
  }

  return true
}

// Функция выполнения отчета (аналогично DiagnosticsSidebar)
const hasError = ref(false);
const lastErrorMessage = ref('');

const executeVehicleReport = (e) => {

  hasError.value = false;
  lastErrorMessage.value = '';
  setStatusText('');

  const isCtrlPressed = e.ctrlKey; // true, если нажат Ctrl (или Cmd на Mac)
  const isMetaPressed = e.metaKey; // для Mac (Cmd)

  const offset = '5';
  const beginTime = (dateRange.value[0].getTime() / 1000).toString();
  const endTime = (dateRange.value[1].getTime() / 1000).toString();
  const areaId = '#section-violations';
  const formId = 'vehicle-dashboard-form';
  const buttonId = 'vehicle-dashboard-get-template-button-test';

  const type = groupingType2.value;

  const listLastTimeAggregation = {};

  for (const id of selectedTsListSync.value) {
    if (globalObjectsList[id]) {
      listLastTimeAggregation[id] = globalObjectsList[id].last_time_aggregation;
    }
  }

  globalObjects.nodeSettings = {
    isCtrlPressed: isCtrlPressed || isMetaPressed,
    listLastTimeAggregation,
    login: userData?.user?.login,
    VueLoadingProcess: (message) => {
      if (hasError.value) {
        setStatusText(lastErrorMessage.value);
        return;
      }
      console.log('Loading process:', message);
      setStatusText(message);
    },
    VueErrorHandler: (errorMessage) => {
      console.error('Error handler:', errorMessage);
      hasError.value = true;
      lastErrorMessage.value = errorMessage;
      isRequestingReport.value = false;
      setStatusText(errorMessage);
    }
  };

  const data = {
    objects: [...selectedTsListSync.value],
    beginTime: beginTime,
    endTime: endTime,
    timeOffset: offset,
    buttonId,
    areaId,
    formId,
    type,
  };

  if (!checkConditions()) {
    isRequestingReport.value = false;
    return
  }
  isRequestingReport.value = true;

  objectsListFormSubmit('vehicle_dashboard', data);
};

onBeforeMount(() => {
  isRequestingReport.value = false;
});

onMounted(() => {
  console.log("testdata", testData.value, props.data);
  
  // Сбрасываем isRequestingReport при получении ответа
  isRequestingReport.value = false;
  
  testData.value = props.data.data;

  // Инициализируем selectedTsList из form_desc.objects, если globalObjectsList уже заполнен
  if (props.form_desc?.objects && props.form_desc.objects.length > 0 &&
      Object.keys(globalObjectsList).length > 0) {
    selectedTsListSync.value = [...props.form_desc.objects];
  }

  // if (testData.value && testData.value.length > 0 && testData.value[0].data) {
  //   const firstData = testData.value[0].data;
  //   if (firstData.interval_begin && firstData.interval_end) {
  //     dateRange.value = [new Date(firstData.interval_begin * 1000), new Date(firstData.interval_end * 1000)];
  //   }
  // }
  clearScreen();
  displayTemplate()
});

// Инициализируем selectedTsList из form_desc.objects при обновлении списка объектов
watch(objectsListUpdateTrigger, () => {
    console.log("trigger")
  if (props.form_desc?.objects && props.form_desc.objects.length > 0 &&
      selectedTsListSync.value.length === 0) {
    selectedTsListSync.value = [...props.form_desc.objects];
  }

  // Автоматическая инициализация при ПЕРВОМ objectsListUpdateTrigger с ненулевым globalObjectsList, если:
  // - юзер не открывал showSelectModal
  // - не изменял dateRange
  // - не изменял groupingType2
  // - globalObjectsList > 100
  if (
    !firstTriggerHandled.value &&
    Object.keys(globalObjectsList).length > 0
  ) {
    firstTriggerHandled.value = true; // Помечаем, что первое срабатывание обработано

    if (
      !userOpenedSelectModal.value &&
      !userChangedDateRange.value &&
      !userChangedGroupingType.value &&
      Object.keys(globalObjectsList).length <= 100
    ) {
      // Устанавливаем selectedTsListSync - все объекты из globalObjectsList
      selectedTsListSync.value = Object.keys(globalObjectsList);

      // Устанавливаем dateRange в зависимости от текущего groupingType2
      setDateRangeByGroupingType();

      // Запускаем executeVehicleReport
      // Создаем фейковый event для executeVehicleReport
      const fakeEvent = { ctrlKey: false, metaKey: false };
      executeVehicleReport(fakeEvent);
    }
  }
}, { immediate: true });

onBeforeUnmount(() => {
  chartInstances.forEach((instance, index) => {
    if (instance) {
      instance.destroy();
      chartInstances[index] = null;
    }
  });
});

const displayTemplate = async () => {
  console.log("displayTemplate", props.data);

  await nextTick();

};

const clearScreen = () => {
  // удаляет только тест "Получен ответ 1 из 1 (100%)"
  const el = document.getElementById('section-reports');
  // templateContentElement.innerHTML = '';

  for (let i = el.childNodes.length - 1; i >= 0; i--) {
    const node = el.childNodes[i];
    // Если это текстовый узел — удаляем
    if (node.nodeType === Node.TEXT_NODE) {
      el.removeChild(node);
    }
  }
}

</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}

.font-weight-bold {
  font-weight: bold;
}

.bg-white {
  background-color: white;
}

.rounded-xl {
  border-radius: 0.75rem;
}

.flex {
  display: flex;
}

.charts-container button {
  border: none;
  background-color: white;
  margin: 0 5px;
}

.justify-between {
  justify-content: space-between;
}

.items-start {
  align-items: flex-start;
}

.items-center {
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
}

.gap-2 {
  gap: 0.5rem;
}

.text-xl {
  font-size: 1.25rem;
}

.font-semibold {
  font-weight: 600;
}

.text-gray-800 {
  color: #1f2937;
}

.group {
  position: relative;
}

.relative {
  position: relative;
}

.justify-center {
  justify-content: center;
}

.cursor-help {
  cursor: help;
}

.text-gray-400 {
  color: #9ca3af;
}

.text-gray-600 {
  color: #4b5563;
}

.text-gray-900 {
  color: #111827;
}

.absolute {
  position: absolute;
}

.bottom-full {
  bottom: 100%;
}

.left-1-2 {
  left: 50%;
}

.transform {
  transform: translateX(-50%);
}

.hidden {
  display: none;
}

.bg-gray-800 {
  background-color: #1f2937;
}

.text-white {
  color: white;
}

.text-xs {
  font-size: 0.75rem;
}

.rounded {
  border-radius: 0.25rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.z-10 {
  z-index: 10;
}

.w-0 {
  width: 0;
}

.h-0 {
  height: 0;
}

.border-l-4 {
  border-left-width: 4px;
}

.border-r-4 {
  border-right-width: 4px;
}

.border-t-4 {
  border-top-width: 4px;
}

.border-l-transparent {
  border-left-color: transparent;
}

.border-r-transparent {
  border-right-color: transparent;
}

.border-t-gray-800 {
  border-top-color: #1f2937;
}

.p-1 {
  padding: 0.25rem;
}

.transition-colors {
  transition: color 0.2s;
}

/* Hover effects */
.hover\:text-gray-600:hover {
  color: #4b5563;
}

.hover\:text-gray-900:hover {
  color: #111827;
}

.hover\:bg-gray-100:hover {
  background-color: #f3f4f6;
}

.group:hover .group-hover\:block {
  display: block;
}

/* Utility classes */
.float-left {
  float: left;
}

.h-5 {
  height: 1.25rem; /* 20px */
}

.w-5 {
  width: 1.25rem; /* 20px */
}

.m-0-5 {
  margin: 0.125rem; /* 2px - this is the closest common size for m-0-5 */
}

/* Existing styles */
* {
  font-family: Arial, sans-serif !important;
  text-align: start;
}

p {
  color: unset;
}

.footer-desc {
  &_period-label {
    font-weight: 700;
  }  
  &_period-val {
    border: 1px solid black;
    padding: 1px;
    font-weight: 400;
    margin-left: 5px;
  } 
  &_group-label {
    font-weight: 700;
    margin-left: 32px;
  }
  &_group-val {
    border-radius: 3px;
    background: none;
    padding: 1px;
    font-weight: 400;
    margin-left: 10px;
    height: 26px;
    width: 122px;
    line-height: 0.9;
    font-size: 18px;

    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: none;
  }
}

.park-dut-name,
.park-work-name,
.park-dutcorrect-name {
  margin-left: 102px;
}

.park-work-name {
  margin-left: 88px !important;
}

.park-dutcorrect-name {
  margin-left: 105px !important;
}

.park-dut-count {
  margin-left: 27px !important;
}

.park-work-count {
  margin-left: 26px !important;
}

.park-dutcorrect-count {
  margin-left: 26px !important;
}

.park-count,
.park-dut-count,
.park-work-count,
.park-dutcorrect-count {
  margin-left: 30px;
  font-size: 20px;
}

.sub-container-title {
  padding-left: 10px;
  font-weight: 900;
  font-size: 18px;
  margin: 0 0 5px 0 !important;
  strong {
    font-size: 20px;
    font-weight: 900;
    line-height: 110%;
    letter-spacing: 0.3px;
  }
}

.mw-unset {
  max-width: unset !important;
}

.of-unset {
  overflow: unset !important;
}

.flex-unset {
  flex: unset !important;
}

.jc-center {
  justify-content: center !important;
}

.table-2 {
  width: 1920px !important;
  min-width: unset;
  margin: 0 auto;
  margin-bottom: 51px;
  position: relative;
}

.charts-container {
  width: 1920px;
  margin: 0 auto;
  // margin-bottom: 20px;
  // height: 337px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.sub-container {
  display: inline-block;
  // border: 1px solid silver;
  font-size: 12px !important;
  height: 100%;
  vertical-align: bottom; 
  box-sizing: border-box; 
}

.chart-wrapper {
  display: inline-block;
  margin-right: 5px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  &.chartContainer {
    display: inline-block;
  }
  
}

.ml-25 {
  margin-left: 25px !important;
}

.ml-15 {
  margin-left: 15px !important;
}

.ml-5 {
  margin-left: 5px !important;
}

.mr-5 {
  margin-right: 5px !important;
}

.date-controls {
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
}

.date-input {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}

.date-input .dp__main {
  margin: 0 !important;
}

.footer-desc :deep(.dp__input) {
  padding: 0 12px !important;
  // font-size: 12px !important;
  // border: 1px solid #ccc !important;
  // border-radius: 3px !important;
  // width: 100px !important;
}

.grouping-select {
  padding: 2px 5px;
  font-size: 12px;
  border: 1px solid #ccc;
  border-radius: 3px;
}

@media print {
  body * {
    visibility: hidden !important;
  }
  .toasts * {
    visibility: hidden !important;
  }
  // body,
  // #app,
  // #section-reports,
  // .monitoring-content {
  //   width: 1920px !important;
  // }
  #vehicle-dashboard-template-content,
  #vehicle-dashboard-template-content * {
    visibility: visible !important;
  }
  .charts-container {
    page-break-inside: avoid;
  }
  #vehicle-dashboard-template-content {
    position: absolute;
    left: 50% !important;
    top: 0;
    width: 1920px !important;
    box-sizing: border-box;
    transform: scale(0.7);
    transform-origin: center top;
    margin-left: -960px !important; /* Move left by half of the original width to center it */
  }

  .highcharts-tooltip-box {
    fill: rgba(255, 255, 255, 0.98) !important;
    stroke: #e5e7eb !important;
    stroke-width: 1px !important;
    filter: drop-shadow(0 4px 6px -1px rgba(0, 0, 0, 0.1));
  } 
}

.chart_header {
  height: 33px;
  margin-bottom: 15px;
}

.sub-container.lampss .chart_header {
  margin-bottom: 0;
}

.excel-bottom-indent {
  margin-top: 13px !important;
  font-size: 18px;
  > span {
    display: inline-block;
    width: 267px;
  }
}

.icons {
  margin: auto 0;
  margin-right: 10px;
  margin-bottom: 3px;
}

.refresh-btn {
  margin-left: 8px;
  padding: 4px 8px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

.refresh-btn:hover {
  background-color: #0056b3;
}

.chart-container-border {
  position: relative !important;
  display: inline-block !important;
}

.chart-container-border::after {
  content: "";
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  border: 1px solid black !important;
  border-radius: 6px !important;
  margin: 0px 10px 57px 10px !important;
  pointer-events: none !important;
}

.bottomlamps {
  position: relative;
  bottom: 39px;
}

.footer-desc_period-label > strong {
  font-weight: 700;
  font-size: 20px;
  line-height: 20px;
}

// .footer-desc_period-label :deep(.dp__pointer.dp__input_readonly.dp__input.dp__input_icon_pad.dp__input_reg.dp-custom-input) {
//   border: none !important;
//   position: relative;
//   bottom: 3px;
//   font-size: 18px;
//   padding: 0;
//   // padding-left: 5px;
// }

// .footer-desc_period-label :deep(.dp__main.dp__theme_light) {
//   width: 71px;
//   display: inline-block;
// }

.footer-desc_period-label :deep(span.line) {
  position: relative;
  top: 7px;
}

.footer-desc_period-label > span >div {
  display: flex;
  margin-left: 9px;
  width: 244px;
  // height: 20px;
  padding-left: 8px;

  // border: 1px solid black;
  vertical-align: sub;
}

.footer-desc_period-label :deep(.dp__main.dp__theme_light) {
  display: inline-block;
}

.footer-desc_period-label :deep(.dp__input_icon_pad) {
  padding-left: 23px !important;
}

// .footer-desc_period-label :deep(.dp__instance_calendar .dp__button.dp__button_bottom) {
//   display: none !important;
// }

// .sub-container.lampss :deep(.highcharts-axis-labels.highcharts-xaxis-labels > span) {
//   top: 45px !important;
// }

// .sub-container.grub :deep(.highcharts-axis-labels.highcharts-xaxis-labels > span) {
//   top: 124px !important;
// }

// .sub-container.rabts :deep(.highcharts-axis-labels.highcharts-xaxis-labels > span) {
//   top: 125px !important;
// }

.error {
  color: red;
  margin-left: 5px;
}

.fix_grub_border-bottom-right {
  width: 10px;
  height: 10px;
  // background: red;
  position: absolute;
  right: 6px;
  bottom: 53.5px;
  z-index: 1;
  // background: radial-gradient(circle at -6% 0%, transparent 6px, white 6.5px);
}
.fix_grub_border-bottom-left {
  width: 10px;
  height: 10px;
  // background: red;
  position: absolute;
  left: 6px;
  bottom: 53.5px;
  z-index: 1;
  // background: radial-gradient(circle at 106% 0%, transparent 6px, white 6.5px);
}

.fix_lamps_border-bottom-right {
  width: 10px;
  height: 10px;
  // background: red;
  position: absolute;
  right: 6px;
  bottom: 53.5px;
  z-index: 1;
  // background: radial-gradient(circle at -6% 0%, transparent 6px, white 6.5px);
}

.fix_lamps_border-bottom-left {
  width: 10px;
  height: 10px;
  // background: red;
  position: absolute;
  left: 6px;
  bottom: 53.5px;
  z-index: 1;
  // background: radial-gradient(circle at 106% 0%, transparent 6px, white 6.5px);
}

.fix_rabts_border-bottom-right {
  width: 10px;
  height: 10px;
  // background: red;
  position: absolute;
  right: 6px;
  bottom: 53.5px;
  z-index: 1;
  // background: radial-gradient(circle at -6% 0%, transparent 6px, white 6.5px);
}

.fix_rabts_border-bottom-left {
  width: 10px;
  height: 10px;
  // background: red;
  position: absolute;
  left: 6px;
  bottom: 53.5px;
  z-index: 1;
  // background: radial-gradient(circle at 106% 0%, transparent 6px, white 6.5px);
}

.charts-container .btn-violation-type-icon,
.charts-container .btn-mileage-icon {
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.25);
}

.footer-desc_group-val :deep(.selected) {
  text-align: center;
  padding: unset;
  padding-top: 4px;
  border: 0.5px solid black;
}

.footer-desc_group-val :deep(li) {
  text-align: center;
  display: grid;
  background: white;
}

.footer-desc_group-val :deep(ul) {
  background: white;
}

.s2_footer-desc_group-val {
  border: 1px solid black;
  padding: 1px;
  font-weight: 400;
  margin-left: 19px;
  height: 19px;
  width: 189px;
  font-size: 12px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: none;
}

.heatmap-panel {
  position: relative;
  width: 1861px;
  border-radius: 5px;
  margin: 0 15px;
  padding: 0 8px;
  padding-bottom: 8px;
  border: 1px solid black;
  background-color: white;
  box-sizing: border-box;
}

.leaflet-map {
  width: 100%;
  height: 339px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-top: 7px;
  position: relative;
  overflow: hidden;
}

@media print {
  .heatmap-panel {
    page-break-inside: avoid;
    margin: 20px auto 0 auto;
  }
}

.map-blur {
  filter: blur(5px);
}

.preloader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 1001;
}

.violation-panel-overlay {
  position: absolute;
  top: 56px;
  height: 314px;
  width: 1843px;
  // position: relative;
  // top: 8px;
  // left: 8px; 
  // width: calc(100% - 16px); 
  // height: calc(100% - 16px);
  z-index: 1002;
  background: white;
  border: 1px solid black;
  border-radius: 5px;
  // padding: 0 8px 8px 8px;
  box-sizing: border-box;
}

.violation-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // padding: 10px;
  // border-bottom: 1px solid #ccc;
}

.violation-table * {
  letter-spacing: 1.8px;
}

.header-left-buttons {
  display: flex;
  gap: 10px;
}

.btn-with-icon-and-text {
  display: flex;
  align-items: center;
  gap: 5px;
}

.btn-violation-type-icon {
  margin-left: 11px !important;
  margin-right: 2px !important;
}

.btn-mileage-icon {
  margin-left: 16px !important;
  margin-right: 10px !important;
}

.btn-violation-type-icon, .btn-mileage-icon, .btn-violation-count-icon {
  background-color: white !important;
  border: 1px solid #ccc !important;
  border-radius: 5px;
  width: 40px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-violation-type-icon.active, .btn-mileage-icon.active {
  background-color: rgba(245, 245, 245, 1) !important;
}

.btn-text {
  font-size: 12px;
  margin-bottom: 9px;
}

.hidden {
  display: none;
}

.btn-mileage-only-icon {
  background-color: white !important;
  border: 1px solid #ccc !important;
  border-radius: 5px;
  padding: 0 5px;
  height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-center-title {
  flex-grow: 1;
  // margin-left: 517px;
  text-align: center;
  font-weight: 700;
  font-size: 18px;
  letter-spacing: 1.8px;
}

.close-panel-btn {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-panel-btn:hover {
  color: #333;
}

.violation-table-container {
  // padding: 10px;
  overflow-x: auto;
  height: 284px;
  overflow-y: auto;
  position: relative;
}

.violation-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.violation-table th,
.violation-table td {
  text-align: center;
}

.violation-table td {
  border-left: none;
  border-right: none;
  text-align: right;
  font-size: 18px;
}

.violation-table th {
  background-color: white;
  border-top: 2px solid black;
  border-bottom: 2px solid black;
  border-left: none;
  border-right: none;
  top: 0;
  padding: 5px;
  font-size: 18px;
  font-weight: 700;
  text-align: right;
}

/* Стиль для строки с пробегом */
.violation-table tr.mileage-row {
  font-size: 12px;
}

.violation-table th[rowspan] {
  vertical-align: middle;
  text-align: center;
}

/* Поворот стрелок на 180 градусов */
.rotated {
  transform: rotate(180deg);
}

/* Стили для детальной таблицы (отдельная панель) */
.detailed-table-overlay {
  position: absolute;
  top: 32px;
  left: 0;
  right: 0;
  bottom: 0;
  // background-color: rgba(0, 0, 0, 0.5);
  z-index: 1002;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detailed-table-overlay-bezop {
  bottom: 8px !important;
  top: unset;
}

.detailed-table-panel {
  background-color: white;
  border-radius: 5px;
  // box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  width: 620px;
  max-height: 334px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 2px solid #2430D3;
  &-malfunction {
    width: 1187px;
  }
}

.detailed-table-panel-bezop {
  max-height: unset !important;
  width: 900px;
}

.detailed-table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #e5e7eb;
  background-color: #f9fafb;
}

.detailed-table-title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.detailed-table-close {
  float: right;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.detailed-table-close:hover {
  background-color: #e5e7eb;
}

.detailed-table-content {
  overflow: auto;
}

.detailed-table-inner {
  width: 100%;
  border-collapse: collapse;
}

.detailed-table-inner th {
  background-color: white;
}

.detailed-table-inner tr:nth-child(2) th {
  top: 50px;
  z-index: 4;
}

/* Стили для иконок сортировки */
.sort-icon {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
}

/* Стили для кнопки назад */
.back-button:hover {
  opacity: 0.8;
}

/* Стили для активных кнопок сортировки */
th[style*="cursor: pointer"]:hover {
  background-color: #f5f5f5;
}

/* Стили для таблицы объема сливов (таблица 2 уровня) */
.fuel-out-detailed-overlay {
  position: absolute;
  top: 32px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1002;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fuel-out-detailed-panel {
  background-color: white;
  border-radius: 5px;
  position: relative;
  width: 1340px;
  max-height: 400px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 2px solid #2430D3;
}

.fuel-out-detailed-note {
  font-size: 12px;
  padding: 0 15px;
  padding-top: 10px;
  line-height: 1.4;
  font-weight: 400;
}

.progress-text {
  position: absolute;
  top: 150px;
  color: black;
  font-size: 14px;
  text-align: center;
  margin-top: 10px;
}

/* Стили для кнопок выбора ТС и выполнения отчета */
.select-ts-btn {
  padding: 0 12px;
  background: none;
  color: black;
  font-size: 18px;
  font-weight: 500;
  height: 26px;
  border: 0.5px solid black;
  border-radius: 3px;
  cursor: pointer;
  // transition: all 0.2s;
  margin-right: 8px;
  position: relative;
  top: 1px;
}

.footer-desc :deep(.target-show > input) {
  background: none;
  color: black;
  padding: 0 .5rem;
  height: 26px;
  font-size: 18px;
  border: 0.5px solid black;
  border-radius: 3px;
  position: relative;
  bottom: 2px;
}

.select-ts-btn:hover {
  background-color: #e5e7eb;
}

.execute-report-btn {
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  color: white;
  background-color: #2563eb;
  border: 1px solid #2563eb;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
}

.execute-report-btn:hover {
  background-color: #1d4ed8;
}

.refresh-btn {
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  background-color: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  margin-left: 8px;
}

.refresh-btn:hover {
  background-color: #e5e7eb;
}

// Адаптация под экраны с шириной < 1920px
@media (max-width: 1919px) {
  .temlate-report {
    transform: scale(0.879);
    transform-origin: top left;
    margin-left: calc((100vw - 1684px) / 2);
  }
}

// 2K (2560×1440) с масштабом Windows 150% (~1707px)
@media (max-width: 1707px) {
  .temlate-report {
    transform: scale(0.711); 
    transform-origin: top left;
    margin-left: calc((100vw - 1358px) / 2);
  }
}

// Full HD с масштабом Windows 125% (эффективное разрешение ~1536px)
// @media (max-width: 1536px) {
//   .temlate-report {
//     transform: scale(0.8); // 1536 / 1920 
//     transform-origin: top left;
//   }
// }

// HD экраны 1366×768
@media (max-width: 1366px) {
  .temlate-report {
    transform: scale(0.667);
    transform-origin: top left;
    margin-left: calc((100vw - 1273px) / 2);
  }
}

// Full HD с масштабом Windows 150% (~1280px), HD Ready 1280×720
@media (max-width: 1280px) {
  .temlate-report {
    transform: scale(0.533); // 1280 / 1920
    transform-origin: top left;
    margin-left: calc((100vw - 1018px) / 2);
  }
}

// Full HD с масштабом Windows 200% (~960px) и планшеты
// @media (max-width: 1024px) {
//   .temlate-report {
//     transform: scale(0.533); // 1024 / 1920
//     transform-origin: top left;
//   }
// }

.disabled-blurred {
  pointer-events: none;
  opacity: 0.5;
  filter: blur(3px);
  transition: all 0.3s ease;
}
</style>